import React from 'react'
import Input from '../../components/Input';
import Button from '../../components/Button';

type Props = {
    email: string;
    setEmail: (value: string) => void;
    bookingNumber: string;
    setBookingNumber: (value: string) => void;
    handlSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    isProcessing: boolean;
}

const BookingReferenceForm = ({
    email,
    setEmail,
    bookingNumber,
    setBookingNumber,
    handlSubmit,
    isProcessing
}: Props) => {

    return (
        <div className="mx-auto max-w-screen-xl px-8 my-8 sm:px-3 lg:px-4">
            <div className="mx-auto max-w-lg text-center">

                <p className="mt-4 text-gray-500">
                    Use your email address and reference ID to view reservation details.
                </p>
            </div>

            <form onSubmit={handlSubmit} className="mx-auto mb-0 mt-8 max-w-md space-y-4">
                <Input
                    type="email"
                    label="Email"
                    pattern=""
                    title=""
                    inputValue={email}
                    setInputValue={setEmail}
                />

                <Input
                    type="text"
                    label="Reference ID"
                    pattern=""
                    title=""
                    inputValue={bookingNumber}
                    setInputValue={setBookingNumber}
                />

                <div className="flex items-center justify-center">

                    <Button
                        btnType="submit"
                        name="Manage"
                        height="12px"
                        isBorderBtn={false}
                        isProcessing={isProcessing}
                        onClickHandler={() => { }}
                    />
                </div>
            </form>
        </div>
    )
}

export default BookingReferenceForm